import { Moment } from 'moment';
import moment from 'moment';
import { useContext } from 'react';
import { DaysContext } from './SingleCalendar';
import isWithinDatesRange from '../../utils/isWithinDatesRange';

interface DayProps {
  date: Moment;
  disabled?: boolean;
  outside?: boolean;
  onClick?: (isoYmd: string) => void;
}

/* eslint-disable complexity */
const Day = ({ date, disabled, outside = false, onClick }: DayProps) => {
  const {
    selectedMonth,
    dateChoice,
    firstRangeStart,
    firstRangeEnd,
    secondRangeStart,
    secondRangeEnd,
    onClick: onClickFromCtx,
    today,
    isDayDisabled,
  } = useContext(DaysContext);

  const className: string[] = [];

  const disabledByPast = !!today && date.isBefore(today, 'day');
  const disabledByBounds = isDayDisabled?.(date) ?? false;
  const isDisabled =
    typeof disabled === 'boolean'
      ? disabled || disabledByPast
      : disabledByPast || disabledByBounds;

  if (today?.isSame(date, 'day')) className.push('current');

  const isWithinFirstRange =
    !!firstRangeStart &&
    !!firstRangeEnd &&
    isWithinDatesRange(firstRangeStart, firstRangeEnd, date);

  const isWithinSecondRange =
    !!secondRangeStart &&
    !!secondRangeEnd &&
    isWithinDatesRange(secondRangeStart, secondRangeEnd, date);

  if (isWithinFirstRange) className.push('between between--first');
  if (isWithinSecondRange && !isWithinFirstRange)
    className.push('between between--second');

  if (outside || (selectedMonth && !date.isSame(selectedMonth, 'month'))) {
    className.push('muted');
  }

  if (dateChoice && date.isSame(moment(dateChoice), 'day')) {
    className.push('active');
  }

  if (isDisabled) className.push('disabled');

  const handleClick = () => {
    if (isDisabled) return;
    const handler = onClick ?? onClickFromCtx;
    handler?.(date.format('YYYY-MM-DD'));
  };

  return (
    <span
      onClick={handleClick}
      data-current-date={date.toISOString()}
      className={className.join(' ')}
      aria-disabled={isDisabled}
    >
      {date.date()}
    </span>
  );
};

export default Day;
